import BaseModel from './BaseModel';
import moment from 'moment';

/** Class representing one individual cron task run result. */
class CronTaskRun extends BaseModel {
    constructor(properties) {
        super(properties);

        if (this.at)
            this.at = moment(this.at);
    }

    /**
     * Short line for list / badge: "500 · Integrity constraint…"
     */
    summaryLine() {
        const parts = [];
        if (this.http_status != null)
            parts.push(String(this.http_status));
        if (this.message)
            parts.push(this.message);
        else if (this.error)
            parts.push(this.error);
        return parts.join(' · ');
    }

    durationLabel() {
        if (this.duration_ms == null || Number.isNaN(this.duration_ms))
            return null;
        if (this.duration_ms < 1000)
            return `${this.duration_ms} ms`;
        return `${(this.duration_ms / 1000).toFixed(1)} s`;
    }
}

export default CronTaskRun;
